module.exports = __webpack_public_path__ + "AnicsChacko-e2369e3d.webp";